import React from 'react';
import { useIntl } from 'react-intl';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';

export default function FormHeader(props) {
  const {
    onClose = () => {}, procedure = '', title = '', titleFull = '', currentApplication, isEdit,
  } = props;
  const { formatMessage } = useIntl();
  return (
    <div className="application-form-header">
      <div className="breadcrumbs">
        <span className="breadcrumbs-prev">заявления</span>
        <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
        {title
          ? (
            <>
              <span className="breadcrumbs-prev">{title}</span>
              <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
            </>
          ) : null}
        {titleFull && titleFull !== title
          ? (
            <>
              <span className="breadcrumbs-prev">{titleFull}</span>
              <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
            </>
          ) : null}
        <span className="breadcrumbs-prev">{formatMessage({
          id: `procedure.type.${procedure}`,
          defaultMessage: ' ',
        })}
        </span>
        <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
        <span className="breadcrumbs-current">Заявление № {currentApplication?.mais_egu_id || 'Без номера'}</span>
        <span className="breadcrumbs-current"> ({isEdit ? 'редактирование' : 'создание'}) </span>

      </div>
      <div className="close-button" onClick={onClose}>
        <Icons width={24} height={24} customIcon icon="close" />
      </div>
    </div>
  );
}
